import * as Rx from '@radix-ui/react-tooltip';
import { cn } from '../lib/cn';

export interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  /** Тёмный (по умолчанию) или светлый тултип (для кликабельного контента, promt-74 §7a). */
  variant?: 'dark' | 'light';
}

/** Тултип (напр. инфо-иконка лимита трафика). */
export function Tooltip({ content, children, variant = 'dark' }: TooltipProps) {
  const light = variant === 'light';
  return (
    <Rx.Provider delayDuration={150}>
      <Rx.Root disableHoverableContent={!light}>
        <Rx.Trigger asChild>{children}</Rx.Trigger>
        <Rx.Portal>
          <Rx.Content
            sideOffset={6}
            className={cn(
              'z-50 max-w-xs rounded-lg px-3 py-2 text-xs leading-snug shadow-pop',
              light ? 'border border-border bg-surface text-fg' : 'bg-fg text-white',
            )}
          >
            {content}
            <Rx.Arrow className={light ? 'fill-surface' : 'fill-fg'} />
          </Rx.Content>
        </Rx.Portal>
      </Rx.Root>
    </Rx.Provider>
  );
}
